'use client';
import { createContext, useContext, useState } from 'react';

const BlogContext = createContext(null);

export const useBlogContext = () => useContext(BlogContext);

export const BlogProvider = ({ children, initialData }) => {
  return (
    <BlogContext.Provider value={{ ...initialData }}>
      {children}
    </BlogContext.Provider>
  );
};
